<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="영어단어의 의미를 파악합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="vx-row flex items-center justify-center">
        <div class="vx-col sm:w-1/2 lg:w-1/2 w-full mb-base">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card style="height:130px" class="flex items-center justify-center">
                  <p class="text-center sentence text-primary">{{ content.sentence }}</p>
              </vx-card>
            </div>
            <div class="vx-col w-full mb-4">
              <vx-card style="height:130px" class="flex items-center justify-center">
                  <p class="text-center sentence ">{{ content.translation }}</p>
              </vx-card>
            </div>
            <div class="vx-col w-full">
              <vs-input-number min="1" max="6" v-model="repeat" />
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col">
          <audio ref="audioPlayer" 
              controls 
              hidden
              v-on:ended="audioFinish" 
              controlsList="nodownload">Your browser does not support the <code>audio</code> element.
          </audio>
        </div>
        
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

const NEXT_WORD_INTERVAL = 1000
const REPEAT_WORD_INTERVAL = 500

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      isStart: false,
      contentList: [],
      contentIndex: 0,
      contentsLen: 0,
      repeat: 3,
      played: 0,
      finished: false,
      isShowImage: true
    }
  },
  watch: {
    sourceContent () {
      this.contentList = []
      this.parseContent()
      this.onReload()
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.isStart = false
      this.contentIndex = 0
      this.played = 0
      this.startAlert()
    },
    onStart () {
      this.isStart = true
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      this.played++
      if (this.played >= this.repeat) {
        if (this.contentIndex === (this.contentsLen - 1)) {
          this.onComplete()
        } else {
        
          setTimeout(function () {
            if (this.studyFinished) return
            this.contentIndex = this.contentIndex + 1
            this.audioPlayer.src = this.content.audio
            this.played = 0
            this.audioPlayer.play()
          }.bind(this), NEXT_WORD_INTERVAL)
        }
      } else {
        setTimeout(function () {
          if (this.studyFinished) return
          this.audioPlayer.play()
        }.bind(this), REPEAT_WORD_INTERVAL)
      }
    },
    startAlert () {
      this.startStudyDlg('영어단어의 의미를 파악합니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    parseContent () {

      const contentJson = JSON.parse(this.sourceContent.contentBody)
      for (let i = 0; i < contentJson.sentence.length; i++) {
        const content = {
          sentence: contentJson.sentence[i],
          translation: contentJson.translation[i],
          audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
        } 
        this.contentList.push(content)
      }
    }
  },
  created () {

    this.parseContent()
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {

  },
  beforeDestroy () { 
    this.audioPlayer.pause()
  }
}

</script>
